import BaseSolutionPage from 'client/common/pages/solution';

import './index.css';

export default BaseSolutionPage;
